import { all, fork } from "redux-saga/effects";
import chatSaga from "./Public/chatsaga";
import privateSaga from "./Private/PrivateSaga";

export default function* rootSaga() {
  yield all([fork(chatSaga), fork(privateSaga)]);
}
